<nz-card class="header-card" nzSize="small">
  <app-custom-breadcrumb [crumbs]="breadcrumbs"></app-custom-breadcrumb>
  <div class="flex justify-between my-3">
    <h2 class="!text-lg xxsm:!text-2xl my-0">News</h2>
  </div>
</nz-card>

<nz-card class="!my-4">
  <div class="max-w-[600px] w-[100%]">
    <div class=" flex justify-start items-center flex-col gap-3 xsm:gap-0 xsm:flex-row">
      <nz-input-group nzSearch nzSize="large" [nzSuffix]="inputClearTpl" [nzAddOnAfter]="suffixIconButton"
        style="max-width: 500px">
        <input type="text" nz-input placeholder="Search News" [(ngModel)]="searchValue" />
      </nz-input-group>
      <ng-template #suffixIconButton>
        <button nz-button nzType="primary" nzSearch (click)="getNewsBySearch()"><span nz-icon
            nzType="search"></span>Search</button>
      </ng-template>
      <ng-template #inputClearTpl>
        <span nz-icon class="ant-input-clear-icon" nzTheme="fill" nzType="close-circle" *ngIf="searchValue"
          (click)="cancelSearch()"></span>
      </ng-template>
    </div>
  </div>
</nz-card>

<div>
  <nz-empty class="mt-10" *ngIf="this.data.length === 0"></nz-empty>
  <div class="mt-4 grid-container">

    <div *ngFor="let news of data" class="bg-white px-3 2xl:px-5 rounded-md relative py-5">
      <div class="flex justify-between items-center gap-4 flex-col xl:flex-row">
        <div class="basis-[40%]  w-full h-[250px]">
          <img class="w-full h-full rounded-md object-contain" alt="image" (error)="onImageError($event)"
            [src]="news.thumbnail.url" />
        </div>
        <div class="basis-[60%]">
          <h4>{{news.title}}</h4>
          <p class="my-4 font-[400]" >{{news.excerpt}}</p>
          <button (click)="viewNews(news.id)" nz-button class="add-post-btn font-medium" target="_blank">
            Read More
          </button>
        </div>
      </div>
    </div>
  </div>

  <div class="flex justify-end">
    <nz-pagination class="!mt-8" (nzPageIndexChange)="onCurrentPageDataChange($event)" [nzPageIndex]="currentPage"
      [nzTotal]="totalDocs" [nzPageSize]="pageSize"></nz-pagination>
  </div>

</div>
